function getPeakDisplay(peak){
    return parseInt(peak) + " kW";
}

export default getPeakDisplay;